import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-translate-2 text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-semibold text-foreground-950">
            日韩中文字幕
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center">
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            订阅更新
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open ? (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 cursor-pointer"
            >
              订阅更新
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}